/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallMerge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 4 5.707 5.707-1.414 1.414L13 7.828v6.586l-6.293 6.293-1.414-1.414L11 13.586v-5.76l-3.293 3.295-1.414-1.414zm2.876 11.461 3.831 3.832-1.414 1.414-3.832-3.831z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallMerge as CallMerge };
